import { useConversationMetadata } from '../conversation/useConversationMetadata'
import { useTaskObj } from './useTaskObj'

export function useIsS3Task(): boolean {
  const taskObj = useTaskObj()
  const request = taskObj?.details?.originalRequest
  const { s3_tar_file_path } = useConversationMetadata()
  const isS3TarFilePathSet = s3_tar_file_path != null && s3_tar_file_path !== ''

  return request?.metadata?.codeContext?.connType === 'S3' || isS3TarFilePathSet
}

export function useS3UploadedPath(): string | undefined {
  const taskObj = useTaskObj()
  const { s3_tar_file_path } = useConversationMetadata()

  const request = taskObj?.details?.originalRequest
  const pathFromTaskObj =
    request?.metadata?.codeContext?.connType === 'S3'
      ? request?.metadata?.codeContext?.s3TarFilePath
      : undefined

  return pathFromTaskObj || s3_tar_file_path
}
